import { defineComponent, onMounted, onUnmounted, computed, ref } from 'vue';
import { useStore } from 'vuex';
import { withLoading } from '@hems/component';
import SmartModuleMobileHomeContainer from '@hems/container/src/forms/device/smartmodule/home/SmartModuleMobileHomeContainer.vue';
import { DeviceServiceUser } from '@hems/service';
import { MobileHelper, useAccessToken, Helper } from '@hems/util';
import { AC_MODEL_TYPE } from '@hems/util/src/constant';
import { DEVICE_ACTION } from '@/stores';
export default defineComponent({
    name: 'SmartModuleMobileHome',
    components: {
        SmartModuleMobileHomeContainer,
    },
    setup() {
        const { accessToken } = useAccessToken();
        window.axiosInstance.setAccessToken(accessToken);
        const deviceService = new DeviceServiceUser(window.axiosInstance.axios);
        const store = useStore();
        const siteId = computed(() => store.state.device?.baseDeviceInfo?.site_id);
        // Add Listener
        MobileHelper.addEventListener('loadAppCtx', (appCtx) => {
            store.dispatch('appCtx/setTheme', appCtx.theme);
            store.dispatch('appCtx/setLangCd', appCtx.theme);
        });
        const selectedDate = ref('');
        MobileHelper.addEventListener('setDate', (date) => {
            selectedDate.value = date;
        });
        function loadAppCtx() {
            MobileHelper.webToApp({
                action: 'mapper_load_appCtx',
                callback: 'loadAppCtx',
            });
        }
        async function getUserInstallationInfo() {
            const { status, result } = await deviceService.getUserInstallationInfo();
            let installationInfo;
            if (Array.isArray(result)) {
                const acCombinerInstallationInfo = result.find((item) => Helper.getACModelType(item.product_model_nm) === AC_MODEL_TYPE.AC_COMBINER);
                installationInfo = acCombinerInstallationInfo ?? result[0];
            }
            else {
                installationInfo = result;
            }
            if (status === 'ok' && installationInfo !== null) {
                store.dispatch('user/setOwnDeviceId', { deviceId: installationInfo.device_id });
                store.dispatch('appCtx/setTimeZone', installationInfo.timezone);
                store.dispatch(DEVICE_ACTION.SET_BASE_DEVICE_INFO, {
                    device_id: installationInfo.device_id,
                    site_id: installationInfo.site_id,
                    timezone_id: installationInfo.timezone,
                    product_model_nm: installationInfo.product_model_nm,
                });
            }
        }
        function openMobileCalendar(calendarMode) {
            if (calendarMode !== 'lifetime') {
                MobileHelper.webToApp({
                    action: 'mapper_open_calendar',
                    params: calendarMode,
                    callback: 'setDate',
                });
            }
        }
        onMounted(() => {
            withLoading(async () => {
                try {
                    loadAppCtx();
                    await getUserInstallationInfo();
                }
                catch (e) {
                    console.log(e);
                }
            })();
        });
        onUnmounted(() => {
            MobileHelper.removeEventListener('loadAppCtx');
            MobileHelper.removeEventListener('setDate');
        });
        return {
            store,
            openMobileCalendar,
            siteId,
            selectedDate,
        };
    },
});
